import React, {Fragment} from 'react';

import withClass from '../../../../hoc/withClass';

const navbarContainer = props => (
    <Fragment>
        {props.children}
    </Fragment>
);

export default withClass(navbarContainer, 'navbar-container container-fluid');